import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Error() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Typography variant="h1" style={{ color: "#344767" }}>
        500
      </Typography>
      <Typography variant="h6" style={{ color: "#344767", marginBottom: "0.35em" }}>
        Lỗi hệ thống, vui lòng thử lại sau.
      </Typography>
      <Button
        sx={{
          width: "auto",
          "&.MuiButton-root.MuiButton-contained": {
            boxShadow: "none !important",
            fontWeight: "normal",
            height: "36px !important",
          },
          "&.MuiButton-root": {
            minHeight: "36px !important",
          },
        }}
        variant="contained"
        size="medium"
        type="button"
        onClick={() => navigate("/")}
      >
        Quay về trang chủ
      </Button>
    </Box>
  );
}
